import { useParams } from "react-router-dom";
import React, { useState } from "react";
import { useGetMonthlyOwingQuery } from "../../Slices/circleApiSlice";

import { Box } from "@mui/material";

import RotationModal from "../shared/RotationModal";
import CurrentPayeeCard from "./ActivePage/CurrentPayeeCard";

function PayoutOrder() {
  const [open, setOpen] = useState(false);

  const { groupId: routeGroupId } = useParams();

  const { data: memberStatusFam } = useGetMonthlyOwingQuery(routeGroupId);

  const payee = memberStatusFam?.payee;

  return (
    <Box>
      {payee && <CurrentPayeeCard {...payee} open={open} setOpen={setOpen} />}
      <RotationModal
        open={open}
        onClose={() => setOpen(false)}
        groupId={routeGroupId}
        title="Payout Order"
        description="Payout Order"
      />
    </Box>
  );
}

export default PayoutOrder;
